export default {
    HELP: 'common-help',
    SIGNATURE_CAPTURE: 'common-signature-capture',

    TOAST: {
        CLOSE_TOAST: 'sp-common-close-toast',
        OPEN_TOAST: 'sp-common-open-toast'
    }
};
